<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card  v-can="'view-project-brief'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">General</label>

              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="['Submitted', 'In-Progress', 'Approved by NPD', 'Approved by Sales', 'Completed']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Assigned Staff</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['staff_id']"
                         :options="staffs" label="name"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Customer</label>
              <v-select  :clearable="true" placeholder="" :reduce="option => option.value"  v-model="filters['customer_id']"
                         :options="customers" label="name"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Industry Sector</label>
              <v-select  :clearable="true" placeholder="" :reduce="option => option.id"  v-model="filters['industry_sector']"
                         :options="industry_sectors" label="name"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['from']" placeholder="Choose Date" />
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['to']" placeholder="Choose Date" />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <vx-card v-if="showStatsFilters" v-can="'view-project-brief'" titleIcon="CalendarIcon" title="Stats Date Range" class="mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="statsFilters.from" placeholder="Choose Date" />
            </div>
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="statsFilters.to" placeholder="Choose Date" />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                @click="statsFilters = { from: moment().startOf('month').format('DD/MM/YYYY'), to: moment().endOf('month').format('DD/MM/YYYY') }">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <div class="vx-row items-center">
          <div class="vx-col w-1/4">
            <vx-card class="overflow-hidden mb-base">
              <div slot="no-body" class="p-6 flex justify-between flex-row-reverse items-center">
                <div class="flex" style="gap: 10px;">
                  <div class="cursor-pointer" @click="showStatsFilters = !showStatsFilters">
                    <feather-icon icon="CalendarIcon" svgClasses="h-8 w-8 text-primary" />
                  </div>
                  <div class="cursor-pointer" @click="$refs.projectBriefReportExportPopUp.openPopup(statsFilters.from, statsFilters.to)">
                    <feather-icon icon="DownloadIcon" svgClasses="h-8 w-8 text-warning" />
                  </div>
                </div>
                <div class="truncate">
                  <p class="mb-1 font-bold text-base">{{ statsFilters.from || '—' }} – {{ statsFilters.to || '—' }}</p>
                  <span>Period</span>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-1/4">
            <shortcut-card hideChart class="mb-base" :icon="'ClockIcon'" icon-right
              :statistic="brief_completion_rate.open != null ? String(brief_completion_rate.open) : '0'"
              :iconRight="true" :statisticTitle="'Open'" :color="'#ff9f43'" />
          </div>
          <div class="vx-col w-1/4">
            <shortcut-card hideChart class="mb-base" :icon="'CheckSquareIcon'" icon-right
              :statistic="brief_completion_rate.completed != null ? String(brief_completion_rate.completed) : '0'"
              :iconRight="true" :statisticTitle="'Completed'" :color="'#39b24b'" />
          </div>
          <div class="vx-col w-1/4">
            <shortcut-card hideChart class="mb-base" :icon="'CheckCircleIcon'" icon-right
              :statistic="brief_completion_rate.completion_rate != null ? brief_completion_rate.completion_rate + '%' : 'N/A'"
              :iconRight="true" :statisticTitle="'Brief Completion Rate'" :color="'#39b24b'" />
          </div>
        </div>
        <vx-card title="PROJECT BRIEF">
          <template v-can="'create-edit-project-brief'" slot="actions">
            <div class="flex">
              <excel-download :name="'project-brief-sheet'" :filters="filters"/>
              <vs-button @click="onClickCreateSite" class="mr-4 mb-4" color="primary" type="filled">Create</vs-button>
            </div>
          </template>
          <div v-can="'view-project-brief'" slot="no-body" class="mt-4">
<!--            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"-->
<!--                      v-model="filters['search']"-->
<!--                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />-->
            <vs-table
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="staff"
              @sort="handleSort"
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="5%" sort-key="project_brief_code">PROJECT BRIEF CODE</vs-th>
                <vs-th width="10%" sort-key="name">PROJECT BRIEF NAME</vs-th>
                <vs-th width="5%">CREATED AT</vs-th>
                <vs-th width="5%">DATE REQUIRED</vs-th>
                <vs-th width="10%">FORMULATIONS</vs-th>
                <vs-th width="10%">ASSIGNED STAFF</vs-th>
                <vs-th width="10%">CUSTOMER</vs-th>
                <vs-th width="10%">INDUSTRIAL SECTOR</vs-th>
                <vs-th width="10%">STATUS</vs-th>

                <vs-th width="10%" v-can="'create-edit-project-brief'">CHANGE STATUS TO</vs-th>
                <vs-th width="10%" v-can="'create-edit-project-brief'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickCustomerSiteUpdate(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].project_brief_code">
                    {{ data[indextr].project_brief_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name}}
                  </vs-td>
                  <vs-td>
                    {{ formatDate(data[indextr].created_at) }}
                  </vs-td>
                  <vs-td :class="dueDateGenerate(data[indextr].date_required)">
                    {{ data[indextr].date_required }}
                  </vs-td>

                  <vs-td :data="data[indextr].formulations">
                    <span v-if="data[indextr].formulations.length > 0" v-for="(item, index) in data[indextr].formulations" :key="item.id">
                      <a @click="onClickFormula(item.id)">{{ item.formulation_code }}</a><span v-if="index < data[indextr].formulations.length - 1">, </span>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].assigned_staff">
                    <template v-if="Array.isArray(data[indextr].assigned_staff) && data[indextr].assigned_staff.length">
                      <span v-if="data[indextr].assigned_staff.length === 1">{{ data[indextr].assigned_staff[0].name }}</span>
                      <vx-tooltip v-else :text="data[indextr].assigned_staff.map(s => s.name).join(', ')" position="top" style="display: inline-block">
                        <span>{{ data[indextr].assigned_staff.length }} staff members</span>
                      </vx-tooltip>
                    </template>
                  </vs-td>

                  <vs-td :data="data[indextr].customer_name">
                     <HyperLink :id="data[indextr].customer_id" type="customer">{{ data[indextr].customer_name }}</HyperLink>
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].customer_industry_sector && data[indextr].customer_industry_sector.length > 0" class="text-sm" v-for="(sector, index) in data[indextr].customer_industry_sector" :key="index">
                      {{ sector ? sector.name : '' }}<span v-if="index < data[indextr].customer_industry_sector.length - 1">, </span>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip transparent :color="projectBriefColorFactory(data[indextr].status.id)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td v-can="'create-edit-project-brief'">
                    <div class="vx-row">
                      <vx-tooltip v-if="tr.status.id === 1" class="m-2" text="Approved by Sales" position="left">
                        <vs-button @click.stop="openStatusChangeConfirm(data[indextr].id, 'approved_by_sales')"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-check">Approved by Sales</vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="tr.status.id === 2" class="m-2" text="Approved by NPD" position="left">
                        <vs-button @click.stop="openStatusChangeConfirm(data[indextr].id, 'approved_by_npd')"
                                   size="small" color="success" type="border" icon-pack="feather" icon="icon-check">Approved by NPD</vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="tr.status.id === 3" class="m-2" text="In-Progress" position="left">
                        <vs-button @click.stop="openStatusChangeConfirm(data[indextr].id, 'in_progress')"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-repeat">In-Progress</vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="tr.status.id === 4" class="m-2" text="Completed" position="left">
                        <vs-button @click.stop="openStatusChangeConfirm(data[indextr].id, 'complete')"
                                   size="small" color="#00adb5" type="border" icon-pack="feather" icon="icon-flag">Completed</vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="tr.status.id === 5" class="m-2" text="Re-open" position="left">
                        <vs-button @click.stop="openStatusChangeConfirm(data[indextr].id, 'in_progress')"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-circle">Re-open</vs-button>
                      </vx-tooltip>
                    </div>

                  </vs-td>

                  <vs-td v-can="'create-edit-project-brief'">
                    <div class="vx-row">
                      <vx-tooltip text="View/Update Project Brief" position="left">
                        <vs-button @click.stop="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip class="ml-2" text="Add a new formulation" position="left">
                        <vs-button @click.stop="onClickCreateFormulation(data[indextr].id)"
                                   size="small" color="primary" type="filled" icon-pack="feather" icon="icon-plus"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip class="ml-2" text="View related formulations" position="left">
                        <vs-button @click.stop="onClickViewRelatedFormula(data[indextr].project_brief_code)"
                                   size="small" color="primary" type="filled" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
<!--            <div class="vx-row mb-3">-->
<!--              <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--                <vs-dropdown class="m-4 float-left">-->
<!--                  <a class="flex items-center" href="#">Per Page<i class="material-icons"> expand_more </i></a>-->
<!--                  <vs-dropdown-menu>-->
<!--                    <vs-dropdown-item v-if="page !== perPage" v-for="(page, index) in perPageList" @click="perPage = page">{{page}}</vs-dropdown-item>-->
<!--                  </vs-dropdown-menu>-->
<!--                </vs-dropdown>-->
<!--                <vs-chip class="float-left mt-4" color="primary">-->
<!--                  {{perPage}}-->
<!--                </vs-chip>-->
<!--              </div>-->
<!--              <div class="vx-col md:w-1/2 w-full md:mb-0">-->

<!--              </div>-->
<!--            </div>-->
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <update-customer-project-brief-pop-up ref="UpdateCustomerProjectBriefPopUp" />
    <create-customer-project-brief-pop-up ref="createCustomerProjectBriefPopUp" />
    <create-formulation-pop-up ref="createFormulationPopUp"/>
    <project-brief-report-export-pop-up ref="projectBriefReportExportPopUp" />

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  const CustomerRepository = RepositoryFactory.get('customer')
  const DropDownRepository = RepositoryFactory.get('drop_down')
  const ReportingRepository = RepositoryFactory.get('reporting')
  import UpdateCustomerProjectBriefPopUp from '@/components/popups/customer/project-brief/UpdateCustomerProjectBriefPopUp'
  import CreateCustomerProjectBriefPopUp from '@/components/popups/customer/project-brief/CreateCustomerProjectBriefPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import CreateFormulationPopUp from '@/components/popups/formulations/CreateFormulationPopUp'
  import ProjectBriefReportExportPopUp from '@/components/popups/customer/project-brief/ProjectBriefReportExportPopUp'
  import {mapActions, mapGetters} from "vuex";
  import moment from 'moment';
  import ShortcutCard from '@/components/shortcut-cards/ShortcutCard.vue';

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        statsFilters: {
          from: moment().startOf('month').format('DD/MM/YYYY'),
          to: moment().endOf('month').format('DD/MM/YYYY'),
        },
        showStatsFilters: false,
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        customers:[],
        staffs:[],
        brief_completion_rate: {}
      }
    },
    components: {
      'v-select': vSelect,
      flatPickr,
      ShortcutCard,
      UpdateCustomerProjectBriefPopUp,
      CreateCustomerProjectBriefPopUp,
      CreateFormulationPopUp,
      ProjectBriefReportExportPopUp,
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      if (this.$route.query.open ) {
        await this.$refs.UpdateCustomerProjectBriefPopUp.openPopup(this.$route.query.open)
      }
      this.setFilterId('project_brief_list_filters',['search', 'status', 'staff_id', 'customer_id', 'industry_sector'])
      await this.fetchCustomersList()
      await this.fetchStaffList()
      await this.fetchIndustrySections()
    },
    methods: {
      ...mapActions([ 'fetchIndustrySections']),
      async refreshData () {
        this.fetchProjectBrief()
        this.fetchProjectBriefCompletionRate()
      },

      async fetchProjectBrief() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getProjectBriefList(this.page, this.filterQuery, this.perPage, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },

      async fetchCustomersList(){
        this.$vs.loading()
        const {data} = await DropDownRepository.getCustomersList()
        this.customers = data.data.map((x) => ({ name: x.company_name, value: x.id }))
        this.$vs.loading.close()
      },

      async fetchStaffList(){
        this.$vs.loading()
        const {data} = await DropDownRepository.getStaffList()
        this.staffs = data.data.map((x) => ({ name: x.name, value: x.id }))
        this.$vs.loading.close()
      },

      async onClickCustomerSiteUpdate (id) {
        await this.$refs.UpdateCustomerProjectBriefPopUp.openPopup(id)
      },
      async onClickCreateSite () {
        await this.$refs.createCustomerProjectBriefPopUp.openPopup()
      },

      async openStatusChangeConfirm(id, status) {
          let confirmText = 'Are you sure you want to make this change?'

          if (status === 'complete') {
              try {
                  const { data } = await CustomerRepository.getApplicationItems(id)
                  const formulations = data.data || []

                  if (formulations.length !== 0) {
                      const formulationsWithoutItems = formulations.filter(
                          formulation => !formulation.application_items || formulation.application_items.length === 0
                      )

                      if (formulationsWithoutItems.length > 0) {
                          const names = formulationsWithoutItems.map(f => f.formulation_code).join(', ')
                          confirmText = `Application information is blank for the following formulations: ${names}. Do you still want to proceed?`
                      }
                  }
              } catch (error) {
                  console.error(error)
                  this.$vs.notify({ title: 'Error', text: 'Failed to check application items', color: 'danger' })
                  return
              }
          }

          this.$vs.dialog({
              type: 'confirm',
              color: status === 'reject' ? 'danger' : 'success',
              title: 'Confirm',
              text: confirmText,
              accept: this.changeProjectBriefStatus,
              parameters: [id, status]
          })
      },
      async changeProjectBriefStatus (params) {
        this.$vs.loading()
        try {
          await CustomerRepository.changeProjectBriefStatus(params[0], params[1])
          this.showSuccessMessage('Project brief status updated!')
          await this.fetchProjectBrief()
          await this.fetchProjectBriefCompletionRate()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async fetchProjectBriefCompletionRate() {
        try {
          const { data } = (await ReportingRepository.getProjectBriefCompletionRate(this.statsFilters.from, this.statsFilters.to)).data
          this.brief_completion_rate = data
        } catch (error) {
          this.convertAndNotifyError(error)
        }
      },

      filterQueryUpdate (){
        this.fetchProjectBrief()
        this.fetchProjectBriefCompletionRate()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchProjectBrief()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchProjectBrief()
        }

      },
      async onClickCreateFormulation (pb_id) {
        await this.$refs.createFormulationPopUp.openPopup(pb_id)
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      onClickViewRelatedFormula(code) {
        this.$router.push({path: `/pages/formulations?search=${code}`})
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return '#a0937d';
          case 2:
            return 'primary';
          case 3:
            return 'success';
          case 4:
            return 'warning';
          case 5:
            return '#00adb5';
        }
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      formatDate(date) {
        return date ? moment(date).format('DD/MM/YYYY') : ''
      },
      dueDateGenerate(date) {
        if(!date) return ''
        let now = moment()
        let ddd = moment(date, 'DD/MM/YYYY')
        let gap = ddd.diff(now, 'days')
        return 0 <= gap && gap <= 5 ? 'text-danger' : ''
      }

    },
    watch : {
      statsFilters: {
        handler () { this.fetchProjectBriefCompletionRate() },
        deep: true,
      },
      page(){
        this.fetchProjectBrief()
      },
      perPage() {
        this.fetchProjectBrief()
      }
    },
    computed: {
      ...mapGetters([ 'industry_sectors'])
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
